<template>
  <div
    class="form__input"
    :class="{'form__input--error': !!error }"
  >
    <label
      v-if="label"
      :for="id"
      class="form__label"
    >
      {{ label }}
    </label>

    <div class="row form-row">
      <div class="col-12 col-md-6" v-show="!hideDayPicker">
        <div
          class="custom-input-wrapper"
          :class="{'input__error': !!error, 'has-input': value !== '' }"
        >
          <datepicker
            :id="id"
            :clear-button="true"
            :required="required"
            :disabled="disabled"
            :input-class="{ 'input': true }"
            :name="name"
            :value="datePickerValue"
            :disabled-dates="disabledDates"
            @input="updateValue"
            @blur="$emit('blur')"
          />
        </div>
      </div>

      <div class="col-12 col-md-6" :class="{'has-time-label': !!timeLabel}">
        <label class="replacement-label" v-if="timeLabel">{{timeLabel}}</label>
        <vue-timepicker manual-input v-model="start_time_time" format="hh:mm A" placeholder="Select Time"></vue-timepicker>
      </div>
    </div>

    <p
      v-show="error"
      class="form__error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import moment from 'moment';

export default {
  components: {
    Datepicker,
    VueTimepicker,
  },
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.datePickerValue;
    },
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Form Label',
    },
    timeLabel: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'form-name',
    },
    id: {
      type: String,
      default: 'form-id',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearButton: {
      type: Boolean,
      default: false,
    },
    hideDayPicker: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },
    disabledDates: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      datePickerValue: null,
      start_time_time: '',
    };
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset(value) {
      this.datePickerValue = value;

      if (this.datePickerValue) {
        this.start_time_time = moment(this.datePickerValue).local().format("hh:mm A");
      } else {
        this.start_time_time = '';
      }
    },
    updateValue(v) {
      this.datePickerValue = v || null;
      this.getDateTime(this.start_time_time);
    },
    clearInput() {
      this.updateValue(null);
    },
    getDateTime(timeStr) {
      let iso = '';
      if (this.datePickerValue) {
        let date = moment(this.datePickerValue).startOf('day');
        const time = moment(timeStr, 'hh:mm A');

        date = date.set({
          hour:   time.get('hour'),
          minute: time.get('minute'),
          second: 0,
        });

        iso = moment(date).local().toISOString();
      }
      this.$emit('input', iso);
      this.$emit('change', 'input', iso);
    }
  },
  watch: {
    value(v) {
      // if our vModel value changes from something else, update the UI here
      this.updateValue(v);
    },
    start_time_time(v) {
      this.getDateTime(v);
    },
  }
};
</script>

<style lang="scss">
  .vdp-datepicker__clear-button,
  .vdp-datepicker__calendar-button {
    position: absolute;
    top: 14px;
    right: 15px;
    font-size: 22px;
    font-style: normal;
    cursor: pointer;
    opacity: 0.4;

    &:hover {
      opacity: 0.8;
    }
  }

  .custom-input-wrapper.has-input ~ .form__label {
    top: 10px !important;
    font-size: 12px;
    color: $blue !important;
  }

  .has-time-label {
    margin-top: -27px;

    @media (max-width: $md-max) {
      margin-top: 0;
    }
  }
</style>
